<template>
  <nav class="mega-menu-wrapper header__mega-menu mega-menu-desktop">
    <ul class="mega-menu mega-menu--depth-1">
      <mega-menu-level-1 v-for="(item, index) in items"
        :item="item"
        :index="index"
        :key="`mega-menu-1-${index}`"
        @menuChange="menuChange"
        ref="megaMenuLevel1" />
    </ul>
  </nav>
</template>

<script>
import MegaMenuLevel1 from "@/components/layout/header/MegaMenu/MegaMenuLevel1";

export default {
  name: 'mega-menu',
  components: {
    MegaMenuLevel1
  },
  props: ["items"],
  methods: {
    menuChange() {
      this.$refs.megaMenuLevel1.forEach((item) => {
        item.closeMegaMenu();
      });
    }
  },
}
</script>